import { render, staticRenderFns } from "./StoreSales.vue?vue&type=template&id=7312b312&scoped=true"
import script from "./StoreSales.vue?vue&type=script&lang=js"
export * from "./StoreSales.vue?vue&type=script&lang=js"
import style0 from "./StoreSales.vue?vue&type=style&index=0&id=7312b312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312b312",
  null
  
)

export default component.exports